<template :id="propX" />
<script>
import axios from "@axios";
import QRCodeStyling from "qr-code-styling";
import {
  guardSubscriptionAction,
  ActionRequirement,
} from '@/libs/subscriptionActionGuard'
import { waitForPrintAssets } from './printAssetReadiness'
// import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  props: {
    userID: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      moved: false,
      title: "",
    };
  },
  computed: {
    //
  },
  watch: {
    // ["options.data"]: function () {
    //   this.qrCode.update(this.options);
    // },
  },
  async mounted() {
    var isOnline = this.$route.query.online != undefined;
    const isReprint = this.$route.query.reprint !== undefined
    let source = 'print-route-exercise-create'
    if (isOnline) source = 'print-route-online-create'
    else if (isReprint) source = 'print-route-reprint'
    const decision = await guardSubscriptionAction({
      requirement: isOnline || !isReprint
        ? ActionRequirement.SUBSCRIPTION_AND_STANDING
        : ActionRequirement.SUBSCRIPTION_ONLY,
      source,
    })
    if (!decision.allowed) {
      this.failPrint()
      return
    }
    // (`${path.list + this.$route.params.id}`)
    // document.addEventListener("change", () => {
    //   if ((window.imgNow = window.imgTotal)) {
    //     window.print();
    //   }
    // });
    window.addEventListener("afterprint", function () {
      window.close();
    });
    let title = "";
    // const iconPath = "http://213.238.181.188:3000/images/";
    const iconPath = axios.defaults.baseURL + "/images/";
    let axiosRoute = ``;
    // console.dir(this.$route);
    if (this.$route.query.answer != undefined) {
      title = "ANSWER";
      if (this.$route.query.session != undefined || this.$route.query.session != null) {
        axiosRoute = `${`exercises/reprint/${this.userID}?session=${this.$route.query.session}&answer=1`}`;
      } else {
        axiosRoute = `${`exercises/reprint/${this.userID}?id=${this.$route.query.exercise}&answer=1`}`;
      }
    } else {
      if (!isOnline) title = "EXERCISE";
      if (this.$route.query.reprint != undefined) {
        if (this.$route.query.session != undefined || this.$route.query.session != null) {
          axiosRoute = `${`exercises/reprint/${this.userID}?session=${this.$route.query.session}`}`;
        } else {
          axiosRoute = `${`exercises/reprint/${this.userID}?id=${this.$route.query.exercise}`}`;
        }
        if (isOnline) {
          console.log("online printing");
          console.log(`Online printing started for user: ${this.userID}`);
          axios
            .post(`/online/${this.userID}`, {})
            .then(res => {
              console.log("Online session created:", res.data);
              console.log(
                `${window.location.origin}/online/host/${res.data.subject}/${res.data.uuid}`
              );
              // return;
              window.location.href = `${window.location.origin}/online/host/${res.data.subject}/${res.data.uuid}`;
            })
            .catch(() => this.failPrint())
          return;
        }
      } else if (
        this.$route.query.session != undefined ||
        this.$route.query.session != null
      ) {
        if (this.$route.query.amount != undefined || this.$route.query.amount != null) {
          `${`exercises/${this.userID}?amount=${this.amount}&session=${this.$route.query.session}`}`;
        } else {
          axiosRoute = `${`exercises/${this.userID}?session=${this.$route.query.session}`}`;
        }
      } else {
        axiosRoute = `${`exercises/${this.userID}?amount=${this.amount}`}`;
      }
    }
    if (!isOnline)
      history.replaceState(
        { id: "0", source: "web" },
        "EGZERSIZ",
        `${window.location.origin}`
      );

    const exerciseParse = require("./exerciseParser.js");
    const exerciseStyle = require("./style.js");

    axios.post("/" + axiosRoute).then((res) => {
      if (isOnline) {
        console.log("online printing");
        console.log(`Online printing started for user: ${this.userID}`);
        return axios
          .post(`/online/${this.userID}`, {})
          .then(onlineRes => {
            console.log('Online session created:', onlineRes.data)
            console.log(
              `${window.location.origin}/online/host/${onlineRes.data.subject}/${onlineRes.data.uuid}`,
            );
            window.location.href = `${window.location.origin}/online/host/${onlineRes.data.subject}/${onlineRes.data.uuid}`
          })
          .catch(() => this.failPrint())
      }
      document.getElementById("loading-bg").style.display = "block";

      const wrapper = document.getElementById("app");
      wrapper.className = "";
      return exerciseParse(res.data, iconPath).then(parse => {
        wrapper.innerHTML = parse;

        // return;
        const pageImgs = document.querySelectorAll("img:not([src='/logo.png'])");
        const qrCodePromises = []

        // document.addEventListener("mousemove", function () {
        // if (this.moved) return;
        // this.moved = true;
        // console.log(this.moved);
        // console.log("mousemove");
        const qrCodes = document.querySelectorAll(".QR");
        qrCodes.forEach(function (qrCode) {
          console.log("qrcode start");
          // console.log(qrCode.dataset.url);
          // console.log("width: " + qrCode.offsetWidth, "height: " + qrCode.offsetHeight);
          // console.log(
          //   "myWidth: " + qrCode.style.width,
          //   "myHeight: " + getComputedStyle(qrCode).height
          // );
          const qrC = new QRCodeStyling({
            width: 300,
            height: 300,
            data: qrCode.dataset.url,
            margin: 0,
            padding: 0,
            qrOptions: {
              typeNumber: "0",
              mode: "Byte",
              errorCorrectionLevel: "Q",
            },
            imageOptions: { hideBackgroundDots: true, imageSize: 0.3, margin: 0 },
            dotsOptions: { type: "dots", color: "#000000" },
            backgroundOptions: { color: "#ffffff" },
            dotsOptionsHelper: {
              colorType: { single: true, gradient: false },
              gradient: {
                linear: true,
                radial: false,
                color1: "#6a1a4c",
                color2: "#6a1a4c",
                rotation: "0",
              },
            },
            cornersSquareOptions: { type: "dot", color: "#000000" },
            cornersSquareOptionsHelper: {
              colorType: { single: true, gradient: false },
              gradient: {
                linear: true,
                radial: false,
                color1: "#000000",
                color2: "#000000",
                rotation: "0",
              },
            },
            cornersDotOptions: { type: "", color: "#000000" },
            cornersDotOptionsHelper: {
              colorType: { single: true, gradient: false },
              gradient: {
                linear: true,
                radial: false,
                color1: "#000000",
                color2: "#000000",
                rotation: "0",
              },
            },
            backgroundOptionsHelper: {
              colorType: { single: true, gradient: false },
              gradient: {
                linear: true,
                radial: false,
                color1: "#ffffff",
                color2: "#ffffff",
                rotation: "0",
              },
            },
            image: `${iconPath + "dikoicomono.png"}`,
          });
          // use the qr-code-styling library to create a qr-code
          // console.log(qrC, qrCode);
          qrC._canvas.style.width = "75px";
          qrC._canvas.style.height = "75px";
          qrC._canvas.style.margin = "5px";
          qrC.append(qrCode);
          console.log("qrcode appended");
          // qr-code-styling exposes its render-complete promise only on this field.
          // eslint-disable-next-line no-underscore-dangle
          qrCodePromises.push(qrC._canvasDrawingPromise)
        });
        // });
        return waitForPrintAssets(pageImgs, qrCodePromises)
      }).then(({ timedOut, failedAssetCount }) => {
        if (timedOut || failedAssetCount > 0) {
          console.warn('Some print assets did not load completely', {
            timedOut,
            failedAssetCount,
          })
        }
        this.completePrint(exerciseStyle, title)
      })
    }).catch(() => this.failPrint())
    // function QRFILL() {
    //   }

    // QRFILL();
  },
  methods: {
    completePrint(exerciseStyle, title) {
      const exercises = document.querySelectorAll('.exercise-wrapper')
      for (let index = 0; index < exercises.length; index += 1) {
        exercises[index].style.display = 'block'
      }
      document.getElementById('loading-bg').style.display = 'none'
      document.getElementsByTagName('head')[0].innerHTML = exerciseStyle
      document.title = title
      if (!document.title.match(/ANSWER/g)) window.print()
    },
    // Post-pending handoff §6: a gated (402/403012) or failed create must not
    // strand the print window on the infinite loader. The global interceptor
    // already toasts/routes; this just settles the window itself.
    failPrint() {
      const t = key => (typeof this.$t === 'function' ? this.$t(key) : key)
      const loading = document.getElementById('loading-bg')
      if (loading) loading.style.display = 'none'
      const wrapper = document.getElementById('app')
      if (wrapper) {
        wrapper.className = ''
        wrapper.innerHTML = `<div style="padding: 2rem; text-align: center; font-family: sans-serif;">
          <h2>${t('The exercise could not be created.')}</h2>
          <p>${t('You can close this window.')}</p>
        </div>`
      }
    },
  },
  setup() {
    //
  },
};
</script>
<style scoped></style>
